'use strict';
module.exports = {
    ApiBaseUrl: 'https://dev.amplofly-aws.com/public/',
    laravelBaseUrl: 'https://dev.amplofly-aws.com/public/api/',
    cacheType: 'sessionStorage',
    debug: false,
    NodeApiBaseUrl: 'https://dev.amplofly-aws.com/api/',
};
